import { Nav } from "@/components/site/Nav";
import { useAuth } from "@/context/AuthContext";
import { Login } from "@/components/team/Login";
import { TeamArea } from "@/components/team/TeamArea";

export default function Equipo() {
  const { user } = useAuth();
  return (
    <div data-testid="equipo-page">
      <Nav alwaysSolid />
      <section className="team" id="privado">
        <div className="wrap">
          <div className="head">
            <h2>Área del equipo de psicología</h2>
            <p className="lead" style={{ margin: 0 }}>Información reservada de los deportistas (Ley 1581 de 2012 y Ley 1090 de 2006). Solo para el equipo autorizado.</p>
          </div>
          {user === null && <p className="note" data-testid="auth-loading">Verificando sesión…</p>}
          {user === false && <Login />}
          {user && <TeamArea />}
        </div>
      </section>
    </div>
  );
}
